import { getField, updateField } from "vuex-map-fields";
import AxiosWrapper from "~/assets/javascript/AxiosWrapper";
import { translate } from '~/assets/javascript/localization/Localization';
import cloneDeep from "lodash/cloneDeep";

AxiosWrapper.init();

const getDefaultState = () => ({
  questionnaireId: null,
  formData: null,
  allAvailableQuestionsIds: [],
  updatedQuestionIds: [],
  params: {
    question_ids: [],
  },
  loadingMessage: translate('no_data_available'),
  saveInProgress: false
})

export const state = getDefaultState

export const getters = {
  getField
}

export const mutations = {
  resetState(state) {
    Object.assign(state, getDefaultState())
  },
  updateField,
  init(state, getRequestData) {
    state.formData = getRequestData.form_data;
  },
  extractAllQuestionsIds(state) {
    state.allAvailableQuestionsIds = state.formData.questions.map(question => question.id);
  },
  addIdToQuestionnaireIdsParam(state, id) {
    state.params.question_ids.push(id);
  },
  removeIdFromQuestionnaireIdsParam(state, id) {
    let index = state.params.question_ids.indexOf(id);
    state.params.question_ids.splice(index, 1);
  },
  setQuestionnaireIdsParamTo(state, value) {
    let clonedValue = cloneDeep(value);
    state.params.question_ids = clonedValue;
  },
  markQuestionAsUpdated(state, id) {
    if (!state.updatedQuestionIds.includes(id)) {
      state.updatedQuestionIds.push(id);
    }
  },
  clearUpdatedQuestionIds(state) {
    state.updatedQuestionIds = [];
  }
}

export const actions = {
  async init({ state, dispatch, commit }, questionnaireId) {
    commit('resetState')
    commit('updateField', { path: "questionnaireId", value: questionnaireId })

    AxiosWrapper.get(`/data_api/audit/questionnaires/${state.questionnaireId}/questions/assign_templates`, { questionnaire_id: state.questionnaireId }).then(response => {
      commit("init", response.data);
      commit("extractAllQuestionsIds");
    });
  },
  selectQuestionWorkFlow({ state, commit }, { select, id }) {
    if (select) {
      commit("addIdToQuestionnaireIdsParam", id);
    } else {
      commit("removeIdFromQuestionnaireIdsParam", id);
    }
  },
  async selectAllQuestionsWorkflow({ state, commit }, { select }) {
    if (select) {
      commit("setQuestionnaireIdsParamTo", state.allAvailableQuestionsIds);
    } else {
      commit("setQuestionnaireIdsParamTo", []);
    }
  },
  async applyQuestionSettings({ state, commit }) {
    if (state.updatedQuestionIds.length === 0) {
      return;
    }

    const updatedQuestions = state.formData.questions.filter(q => state.updatedQuestionIds.includes(q.id));

    AxiosWrapper.patch(`/data_api/audit/questionnaires/${state.questionnaireId}/questions/update_questions`, { "questions": updatedQuestions })
    .then(response => {
      commit('clearUpdatedQuestionIds');
    });
  },
}